import { images } from "@/utils/images";
import { NoseModal } from "./modals/noseModal";
import { EyesModal } from "./modals/eyesModal";
import { ImplantsModal } from "./modals/implantsModal";
import { EyesLinesModal } from "./modals/eyesLinesModal";
import { AnesthesiaModal } from "./modals/anesthesiaModal";
import { SideEffectsModal } from "./modals/sideEffectsModal";
import { CareModal } from "./modals/careModal";
import { ResurgeryModal } from "./modals/resurgeryModal";
import { ConsultationPrepModal } from "./modals/consultationPrepModal";
import { SafeHospitalModal } from "./modals/safeHospitalModal";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { getLanguage } from "@/utils/localStorageControl";
import { LANGUAGES } from "@/language";

const TableMenu = () => {
  const { push } = useRouter();
  const [currentLang, setCurrentLang] = useState<string>('ko');
  const [openEyesModal, setOpenEyesModal] = useState(false);
  const [openAnesthesiaModal, setOpenAnesthesiaModal] = useState(false);
  const [openCareModal, setOpenCareModal] = useState(false);
  const [openResurgeryModal, setOpenResurgeryModal] = useState(false);
  const [openConsultationPrepModal, setOpenConsultationPrepModal] = useState(false);
  const [openSafeHospitalModal, setOpenSafeHospitalModal] = useState(false);
  const [openNoseModal, setOpenNoseModal] = useState(false);
  const [openSideEffectsModal, setOpenSideEffectsModal] = useState(false);
  
  useEffect(() => {
    const lang = getLanguage();
    setCurrentLang(lang);
  }, []);
  
  const items = [
    { key: '코', image: images.tableNoseIcon, action: () => setOpenNoseModal(true) },
    { key: '눈', image: images.tableEyesIcon, action: () => setOpenEyesModal(true) },
    { key: '마취', image: images.tableSleepingIcon, action: () => setOpenAnesthesiaModal(true) },
    { key: '수술 준비', image: images.tableInquiryIcon, action: () => setOpenConsultationPrepModal(true) },
    { key: '병원 선택법', image: images.tablePrepareIcon, action: () => setOpenSafeHospitalModal(true) },
    { key: '기타', path: '/' },
    { key: '재수술', image: images.tableResurgeryIcon, action: () => setOpenResurgeryModal(true) },
    { key: '수술 후 케어법', image: images.tableCareIcon, action: () => setOpenCareModal(true) },
    { key: '', image: null, action: null },
  ]

  return (
    <div className='max-w-[1280px] pt-[100px] w-full sm:pt-[120px] pb-[40px] mx-auto'>
      <NoseModal forceOpened={openNoseModal} onClose={() => setOpenNoseModal(false)}/>
      <ImplantsModal />
      <SideEffectsModal forceOpened={openSideEffectsModal} onClose={() => setOpenSideEffectsModal(false)} />
      <EyesModal forceOpened={openEyesModal} onClose={() => setOpenEyesModal(false)}/>
      <AnesthesiaModal forceOpened={openAnesthesiaModal} onClose={() => setOpenAnesthesiaModal(false)}/>
      <CareModal forceOpened={openCareModal} onClose={() => setOpenCareModal(false)}/>
      <ResurgeryModal forceOpened={openResurgeryModal} onClose={() => setOpenResurgeryModal(false)}/>
      <ConsultationPrepModal forceOpened={openConsultationPrepModal} onClose={() => setOpenConsultationPrepModal(false)} />
      <SafeHospitalModal forceOpened={openSafeHospitalModal} onClose={() => setOpenSafeHospitalModal(false)} />
      <div className="text-center text-2xl md:text-3xl font-bold text-gray-700 dark:text-gray-100 my-12" data-aos="fade" data-aos-duration="500">
        {(() => {
          // Type guard function to check if the key exists in the object
          const hasKey = <T extends object>(obj: T, key: string | number | symbol): key is keyof T => {
            return key in obj;
          };
          
          if (LANGUAGES.MAIN_PAGE.INTEREST && 
              hasKey(LANGUAGES.MAIN_PAGE.INTEREST, '배우고 싶은 분야를 선택 해주세요') && 
              hasKey(LANGUAGES.MAIN_PAGE.INTEREST['배우고 싶은 분야를 선택 해주세요'], currentLang)) {
            return LANGUAGES.MAIN_PAGE.INTEREST['배우고 싶은 분야를 선택 해주세요'][currentLang];
          }
          return '배우고 싶은 분야를 선택 해주세요';
        })()}
      </div>
      <div className="grid grid-cols-3 gap-4 w-[320px] md:w-[410px] mx-auto" data-aos="fade" data-aos-delay="600" data-aos-duration="500">
        {items.map((item, index) => {
          let label = item.key;
          // Type guard function to check if the key exists in the object
          const hasKey = <T extends object>(obj: T, key: string | number | symbol): key is keyof T => {
            return key in obj;
          };
          
          // LANGUAGES.MAIN_PAGE.INTEREST에 해당 키가 있고, 해당 언어 번역이 있는 경우에만 번역된 텍스트 사용
          if (
            LANGUAGES.MAIN_PAGE.INTEREST && 
            hasKey(LANGUAGES.MAIN_PAGE.INTEREST, item.key) && 
            hasKey(LANGUAGES.MAIN_PAGE.INTEREST[item.key], currentLang)
          ) {
            label = LANGUAGES.MAIN_PAGE.INTEREST[item.key][currentLang];
          }
          const isSideEffect = item.key === '부작용';
          
          return (
            <div
              key={index}
              className={`flex flex-col items-center justify-center gap-3 border-1 border-gray-200 dark:border-gray-700 p-4 text-center text-sm md:text-base w-[100px] h-[100px] md:w-[130px] md:h-[130px] font-normal text-gray-700 dark:text-gray-300 hover:border-blue-400 dark:hover:border-blue-500 hover:text-blue-700 dark:hover:text-blue-400 hover:bg-transparent hover:font-medium transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800 shadow-none`}
              onClick={() => {
                if (item.action) {
                  item.action();
                } else if (item.path) {
                  console.log(item.path);
                  push(item.path);
                }
              }}
            >
              {item.image && <img src={item.image} className="w-8 h-8"/>}
              <div className="text-base font-medium">
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TableMenu;